import { Button, Stack } from "@mui/material";
import MicIcon from '@mui/icons-material/Mic';
import PauseIcon from '@mui/icons-material/Pause';
import StopIcon from '@mui/icons-material/Stop';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';

const RecorderControls = ({ 
    isRecording, 
    isPaused, 
    hasRecording,
    onStart, 
    onPause, 
    onResume, 
    onStop, 
    onSave,
    onDelete
}) => {
    if (hasRecording) {
        return (
            <Stack spacing={2} direction="row" justifyContent="center" my={3}>
                <Button
                    variant="contained"
                    color="success"
                    size="large"
                    startIcon={<SaveIcon />}
                    onClick={onSave}>
                    Salva e Trascrivi
                </Button>
                <Button
                    variant="outlined"
                    color="error"
                    size="large"
                    startIcon={<DeleteIcon />}
                    onClick={onDelete}>
                    Elimina
                </Button>
            </Stack>
        );
    }

    if (!isRecording && !isPaused) {
        return (
            <Stack spacing={2} direction="row" justifyContent="center" my={3}>
                <Button
                    variant="contained"
                    color="error"
                    size="large"
                    startIcon={<MicIcon />}
                    onClick={onStart}
                    sx={{
                        minWidth: 200,
                        animation: 'pulse 2s infinite',
                        '@keyframes pulse': {
                            '0%': { boxShadow: '0 0 0 0 rgba(211, 47, 47, 0.7)' },
                            '70%': { boxShadow: '0 0 0 10px rgba(211, 47, 47, 0)' },
                            '100%': { boxShadow: '0 0 0 0 rgba(211, 47, 47, 0)' }
                        }
                    }}>
                    Inizia Registrazione
                </Button>
            </Stack>
        );
    }

    return (
        <Stack spacing={2} direction="row" justifyContent="center" my={3}>
            {isPaused ? (
                <Button
                    variant="contained"
                    color="success"
                    size="large"
                    startIcon={<PlayArrowIcon />}
                    onClick={onResume}>
                    Riprendi
                </Button>
            ) : (
                <Button
                    variant="contained"
                    color="warning"
                    size="large"
                    startIcon={<PauseIcon />}
                    onClick={onPause}>
                    Pausa
                </Button>
            )}
            <Button
                variant="contained"
                color="error"
                size="large"
                startIcon={<StopIcon />}
                onClick={onStop}>
                Stop
            </Button>
        </Stack>
    );
};

export default RecorderControls;
